<template>
  <v-row class="overflow-auto fill-height">
    <v-col cols="9" class="container-creation">
      <div
        @click="retourStep1 ? step1=!step1:step1=step1"
        class="create-catalog-step step1 d-flex flex-row"
        :class="step1?'background-yellow':'background-gray'"
      >
        <h3 class="number-step">1</h3>
        <h3 class="title-step">Choix du template</h3>
      </div>
      <v-expand-transition>
        <div v-if="step1">
          <catalog-template :catalog="newCatalog" @setCatalog="setCatalog"></catalog-template>
        </div>
      </v-expand-transition>

      <div
        @click="retourStep2 ? step2=!step2:step2=step2"
        class="create-catalog-step step2 d-flex flex-row"
        :class="step2?'background-yellow':'background-gray'"
      >
        <h3 class="number-step">2</h3>
        <h3 class="title-step">Choix des produits</h3>
      </div>
      <v-expand-transition>
        <div v-if="step2">
          <div class="row">
            <v-col>
              <h3 class="h3">Choisir le type de template et les produits</h3>
              <hr />
              <div class="row" v-if="!templateWaySelected">
                <v-col class="d-flex flex-row">
                  <div>
                    <div @click="createFromMatrice()" class="icon-template withpointer">
                      <icon class="template-way-icon" name="list"></icon>
                    </div>
                    <div class="template-way-legende">
                      Créer votre catalogue
                      <br />à partir de la matrice
                    </div>
                  </div>
                  <div @click="createFromNothing()" class="ml-4">
                    <div class="ml-3 icon-template withpointer">
                      <icon class="template-way-icon" name="hand-paper"></icon>
                    </div>
                    <div class="template-way-legende">
                      Créer votre catalogue
                      <br />à la main
                    </div>
                  </div>
                  <div @click="createFromImport()" class="ml-4">
                    <div class="ml-3 icon-template withpointer">
                      <icon class="template-way-icon" name="download"></icon>
                    </div>
                    <div class="template-way-legende">
                      Importer
                      <br />un fichier Excel
                    </div>
                  </div>
                </v-col>
              </div>
              <m-loader-dialog v-model="loaderDialog"></m-loader-dialog>
              <div class="row" v-if="templateWaySelected && !loaderDialog">
                <v-col>
                  <v-row class="mb-4">
                    <v-col cols="5">
                      <!-- <div class="d-flex flex-row btn-switch">
                        <p class="label-switch">Voir les familles</p>
                        <v-switch
                          v-model="showProducts"
                          :name="$Utils.randomstring('showProducts')"
                          color="#4e4e4e"
                          :inset="true"
                          :light="true"
                          label="Voir les produits"
                          class="mt-0 ml-4 mr-2"
                          :hide-details="true"
                        ></v-switch>
                      </div>-->
                      <!-- <m-form-text
                        :name="$Utils.randomstring('search-product')"
                        label="Rechercher"
                        label-position="top"
                        v-model="searchProduct"
                      ></m-form-text>-->
                    </v-col>

                    <v-col cols="7">
                      <v-btn
                        v-if="$store.state.myrights.create_catalogue"
                        class="primary2 btn-create-node"
                        :disabled="createNodeDisabled"
                        depressed
                        @click="createNode()"
                      >Créer un sous-dossier</v-btn>
                    </v-col>
                  </v-row>
                  <hr />

                  <card-tree
                    ref="cardTree"
                    v-if="!showProducts "
                    width="80"
                    :ca_id="ca_id"
                    :catalogName="newCatalog.ca_name"
                    :colCheckbox="false"
                    :colProblems="true"
                    :colEdit="true"
                    :canSelectLine="true"
                    :path="'/catalogs/edit/'+ca_id"
                    @productWinEditOpened="productWinEditOpened"
                    @productWinEditSaved="productWinEditSaved"
                    @productWinEditCanceled="productWinEditCanceled"
                    @changeDataCatalog="changeDataCatalog"
                    @enabledBtnCreateNode="enabledBtnCreateNode"
                  ></card-tree>
                  <m-card-products ref="cardProducts" v-if="showProducts "></m-card-products>
                  <v-menu offset-y allow-overflow auto offset-overflow>
                    <template v-slot:activator="{ on }">
                      <v-btn class="primary2 mt-4" depressed v-on="on">Traductions</v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title @click="tradsExport">Exporter les traductions</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title @click="tradsImport">Importer les traductions</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </div>
            </v-col>
          </div>
          <div class="row">
            <v-col class="d-flex flex-row">
              <v-spacer></v-spacer>
              <v-btn
                v-if="$store.state.myrights.export_catalogue"
                color="primary2"
                depressed
                @click="saveStep2()"
              >Etape suivante</v-btn>
            </v-col>
          </div>
        </div>
      </v-expand-transition>

      <div
        v-if="$store.state.myrights.export_catalogue"
        @click="step3=!step3"
        class="create-catalog-step step3 d-flex flex-row"
        :class="step3?'background-yellow':'background-gray'"
      >
        <h3 class="number-step">3</h3>
        <h3 class="title-step">Imprimer / exporter</h3>
      </div>
      <v-expand-transition v-if="$store.state.myrights.export_catalogue">
        <div v-if="step3">
          <div class="row" v-if="newCatalog.ca_template==1 || newCatalog.ca_template==4">
            <v-col>
              <h3 class="h3">Imprimer</h3>
              <hr />
              <div class="row ml-3">
                <v-col cols="3" class="d-flex flex-row">
                  <div @click="print('basse')">
                    <div class="icon-template withpointer">
                      <icon class="template-way-icon" name="print"></icon>
                    </div>
                    <div class="template-way-legende">
                      Imprimer
                      <br />en basse définition
                    </div>
                  </div>
                </v-col>
                <v-col cols="3">
                  <div class="ml-4" @click="print('haute')">
                    <div class="ml-3 icon-template withpointer">
                      <icon class="template-way-icon" name="print"></icon>
                    </div>
                    <div class="template-way-legende">
                      Imprimer
                      <br />en haute définition
                    </div>
                  </div>
                </v-col>
              </div>
            </v-col>
          </div>
          <div class="row">
            <v-col>
              <h3 class="h3">Exporter</h3>
              <hr />
              <div class="row ml-3">
                <v-col cols="3" class="d-flex flex-row">
                  <div @click="exportExcel">
                    <div class="icon-template withpointer">
                      <icon class="template-way-icon" name="file-excel"></icon>
                    </div>
                    <div class="template-way-legende">
                      Exporter
                      <br />Image HD + excel
                    </div>
                  </div>
                </v-col>
                <v-col cols="3">
                  <div class="ml-4" @click="exportExcel2">
                    <div class="ml-3 icon-template withpointer">
                      <icon class="template-way-icon" name="file-excel"></icon>
                    </div>
                    <div class="template-way-legende">
                      Exporter
                      <br />excel
                    </div>
                  </div>
                </v-col>
              </div>
            </v-col>
          </div>
        </div>
      </v-expand-transition>
    </v-col>
    <v-col cols="3" v-if="newCatalog.ca_template==1 || newCatalog.ca_template==4">
      <div class="mb-6">
        <div v-if="newCatalog.ca_name" class="bis">{{newCatalog.ca_name}}</div>
        <div v-if="newCatalog.ca_name">{{newCatalog.ca_nb_pages}} pages</div>
        <div v-if="newCatalog.ca_name">{{newCatalog.ca_nb_products}} produits</div>
      </div>
      <div class="col-preview">
        <v-img :src="thumbnailSrc" height="350px" width="250px"></v-img>
      </div>
      <div class="d-flex flex-row mx-6 mt-2 align-center">
        <div class="mr-2">Page :</div>
        <div class="mr-2 withpointer" @click="changePage(1)">
          <icon :class="numpage*1===1?'icon-gray':'icon-black'" name="angle-double-left"></icon>
        </div>
        <div class="mr-2 withpointer" @click="changePage(numpage*1-1)">
          <icon :class="numpage*1===1?'icon-gray':'icon-black'" name="angle-left"></icon>
        </div>
        <div class="container-input-page mr-2">
          <m-form-text
            type="number"
            :name="$Utils.randomstring('appercu_page')"
            class="alignright"
            v-model="numpage"
            :max="newCatalog.ca_nb_pages"
          ></m-form-text>
        </div>

        <div class="mr-2 withpointer" @click="changePage(numpage*1+1)">
          <icon
            :class="numpage*1===newCatalog.ca_nb_pages?'icon-gray':'icon-black'"
            name="angle-right"
          ></icon>
        </div>
        <div class="withpointer" @click="changePage(newCatalog.ca_nb_pages)">
          <icon
            :class="numpage*1===newCatalog.ca_nb_pages?'icon-gray':'icon-black'"
            name="angle-double-right"
          ></icon>
        </div>
      </div>
    </v-col>
    <matrice-win-import
      @imported="imported"
      ref="importMatrice"
      what="dans un catalogue"
      :ca_id="newCatalog.ca_id"
    ></matrice-win-import>
      <matrice-win-trads :ca_id="ca_id" ref="importTrads" @imported="importedTrad"></matrice-win-trads>
    <!--  <m-family-win-edit ref="familywinedit" @familyWinEditSaved="familyWinEditSaved" :ca_id="ca_id"></m-family-win-edit> -->
  </v-row>
</template>

<script>
import CatalogTemplate from "../views/CatalogTemplate";
import MatriceWinImport from "../views/MatriceWinImport";
import MatriceWinTrads from "../views/MatriceWinTrads";

export default {
  name: "catalogedit",
    components: {
    "matrice-win-import": MatriceWinImport,
    "catalog-template": CatalogTemplate,
    "matrice-win-trads": MatriceWinTrads,
  },
  data() {
    return {
      numpage: 1,
      thumbnailSrc: "",
      step1: true,
      step2: false,
      step3: false,
      //// step 1 ////
      newCatalog: {
        ca_lang: "fr",
        ca_intro_pages: true,
        ca_separation_pages: true,
        ca_back_cover_france: true,
        ca_name: "",
        ca_cover: true,
        ca_template: 1,
        ca_text1: "",
        ca_text2: "",
        ca_text3: "",
        ca_text4: "",
        ca_image: "",
        ca_logo: "",
        ca_nb_pages: 0
      },
      catalogImage: { image: null, binary: null },
      catalogLogo: { image: null, binary: null },
      deleteLogo: false,
      deleteImage: false,
      ca_id: null,
      retourStep1: false,
      //// step 2 ////
      loaderDialog: false,
      currentSelection: null,
      createNodeDisabled: true,
      templateWaySelected: null,
      searchProduct: "",
      showProducts: false,
      // nbProducts: 0,
      arborescence: {},
      fa_idToLoadProduct: 0,
      showProductsIgnore: false,
      retourStep2: false,

      //// step 3 ////
      retourStep3: false,
      catalog_lang: "fr"
    };
  },
  // filters: {},
  watch: {
    $route(to, from) {
      if (to.name === "catalogeditproducts") {
        //this.fa_idToLoadProduct = parseInt(to.params.fa_id);
        //this.showProducts = true;
      }
    },
    showProducts(val) {
      if (this.showProductsIgnore) return;
      if (val) {
        //this.$router.push("/catalogs/edit/" + this.ca_id + "/products");
        this.$nextTick(() => {
          this.$refs.cardProducts.loadProducts(this.ca_id, {
            noSearchNoProduct: false
          });
        });
      } else {
        //this.$router.push("/catalogs/edit/" + this.ca_id);
      }
    },
    numpage(val) {
      this.loadThumbnail();
    }
  },
  computed: {},
  async mounted() {
    if (this.$route.params.ca_id > 0) {
      let response = await this.$axios.get(
        this.$config.server_url +
          "/api/1.0/catalogs/" +
          this.$route.params.ca_id
      );
      this.newCatalog = response.data.data;
      this.retourStep1 = true;
      this.retourStep2 = true;
      this.retourStep3 = true;
      this.step1 = false;
      this.step2 = true;
      this.step3 = false;
      this.templateWaySelected = 3;
      this.ca_id = this.newCatalog.ca_id;

      //  this.getCatalog();
      this.loadThumbnail();
    }
  },
  destroyed() {},
  methods: {
    imported(ca_id) {
      this.newCatalog.ca_id = ca_id;
      this.ca_id = this.newCatalog.ca_id;
      this.templateWaySelected = 3;
      this.loadThumbnail();
    },
    productWinEditOpened() {
      // this.$router.push("/catalogs/edit/"+this.newCatalog.ca_id);
    },
    productWinEditSaved() {},
    productWinEditCanceled() {},
    setCatalog(catalog) {
      this.newCatalog = catalog;
      this.retourStep1 = true;
      this.step1 = false;
      this.step2 = true;
      // this.newCatalog.ca_nb_pages = 1;
      this.loadThumbnail();
    },
    loadThumbnail(page) {
      this.thumbnailSrc =
        this.$config.server_url +
        "/api/1.0/catalogs/" +
        this.newCatalog.ca_id +
        "/thumbnail/" +
        this.numpage +
        "?token=" +
        this.$store.state.token +
        "&d=" +
        new Date().getTime();
    },
    createNode() {
      this.$refs.cardTree.createLineFamily();
    },

    changePage(page) {
      if (page >= 1 && page <= this.newCatalog.ca_nb_pages) {
        this.numpage = page;
      }
    },
    async changeDataCatalog() {
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/catalogs/" + this.ca_id
      );
      this.newCatalog = response.data.data;
      this.loadThumbnail();
    },
    async createFromMatrice() {
      this.loaderDialog = true;
      this.templateWaySelected = 1;
      // console.log("this.newCatalog", this.newCatalog);
      let params = {
        ca_id: this.newCatalog.ca_id
      };
      // let response =
      await this.$axios.get(
        this.$config.server_url + "/api/1.0/matrice/duplicate",
        { params }
      );
      this.ca_id = this.newCatalog.ca_id;
      this.loaderDialog = false;
      // this.arborescence = response.data.arborescence;
      // this.$refs.cardTree.getCatalog();
    },
    async createFromNothing() {
      this.templateWaySelected = 2;
      this.ca_id = this.newCatalog.ca_id;
    },
    async createFromImport() {
      this.$refs.importMatrice.open();
    },
    enabledBtnCreateNode(child) {
      this.createNodeDisabled = false;
      this.currentSelection = child;
    },
    saveStep2() {
      this.retourStep2 = true;
      this.step2 = false;
      this.step3 = true;
    },
    exportExcel() {
      window.open(
        this.$config.server_url +
          "/api/1.0/catalogs/export/1/" +
          this.newCatalog.ca_id +
          "?lang=" +
          this.catalog_lang +
          "&d=" +
          new Date().getTime(),
        "_blank"
      );
    },
    exportExcel2() {
      window.open(
        this.$config.server_url +
          "/api/1.0/catalogs/export/2/" +
          this.newCatalog.ca_id +
          "?lang=" +
          this.catalog_lang +
          "&d=" +
          new Date().getTime(),
        "_blank"
      );
    },
    async print(quality) {
      window.open(
        this.$config.server_url +
          "/api/1.0/catalogs/print/" +
          this.newCatalog.ca_id +
          "?quality=" +
          quality +
          "&d=" +
          new Date().getTime(),
        "_blank"
      );
    },
    importedTrad() {
      if (this.$refs.cardtree) this.$refs.cardtree.getCatalog();
      if (this.$refs.cardProducts) this.$refs.cardProducts.loadProducts(0);
    },
    tradsExport() {
      window.open(
        this.$config.server_url +
          "/api/1.0/matrice/tradsexport/"+this.ca_id+"?token=" +
          this.$store.state.token,
        "_blank"
      );
    },
    tradsImport() {
      this.$refs.importTrads.open();
    }
    /* async getMatrice(params) {
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/matrice",
        { params }
      );
      this.arborescence = response.data.arborescence;
    } */
  }
};
</script>
<style  lang="scss" scoped>
.container-creation {
  background-color: #fff;
}
.create-catalog-step {
  padding: 8px;
  margin-bottom: 5px;
  align-items: center;
  cursor: pointer;
}
.background-yellow {
  background-color: #fdc90b;
  color: black;
}
.background-gray {
  background-color: #cccccc;
  color: #fff;
  .number-step {
    color: #cccccc;
  }
}
.number-step {
  background-color: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 8px;
  font-size: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.title-step {
  font-size: 24px;
}
.template1 {
  width: 150px;
  height: 200px;
  background-image: url(/img/template1.png);
  background-size: contain;
}
.template2 {
  width: 150px;
  height: 200px;
  background-image: url(/img/template2.png);
  background-size: contain;
}
.template-selected {
  border: solid 3px #fdc90b;
}
.change-template-way {
  text-decoration: underline;
  color: #1f3b80;
}
.template-legende {
  text-align: center;
}
.inputs-texts-couverture {
  margin-left: 40px;
}
.icon-template {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100px;
  .template-way-icon {
    width: 60px;
    height: 60px;
  }
}
#rozenbal .container-img {
  position: relative;
  width: 100%;
  height: 200px;
  border: solid 1px #ebebeb;
}
#rozenbal .container-img .v-image {
  margin-left: auto;
  margin-right: auto;
}

.template-way-legende {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
}
.btn-switch {
  margin-left: 10px;
}
.btn-create-node {
  float: right;
  margin-right: 10px;
}
///// col preview /////
.col-preview {
  width: 100%;
  // position: fixed;
}
.col-preview .v-image {
  box-shadow: 0 0px 5px 2px #cccccc;
  margin-left: auto;
  margin-right: auto;
}
.container-input-page {
  width: 70px;
}
.icon-gray {
  color: #cccccc;
}
.icon-black {
  color: black;
}
</style>